/**
 * Brand detection — which company's UI this deployment serves.
 *
 * The same SPA bundle is deployed to two S3 buckets/CloudFront distributions.
 * Each bucket gets its own CDK-generated /config.json; only the New Western
 * bucket's config carries `brand: "newwestern"` (main.tsx stores it on
 * window.__QDF_BRAND__ before render). The Left Main bucket's config.json is
 * untouched, so its absence of a brand key means Left Main — the existing
 * site renders exactly as before.
 */
export type Brand = 'leftmain' | 'newwestern';

const NW_HOSTNAMES = new Set([
  'apply.quickdrawfunding.com',
  'apply-dev.quickdrawfunding.com',
]);

export function getBrand(): Brand {
  if (window.__QDF_BRAND__ === 'newwestern') return 'newwestern';
  if (window.__QDF_BRAND__ === 'leftmain') return 'leftmain';
  // Fallbacks for local dev / direct CloudFront access where config.json
  // didn't load: hostname, then the VITE_BRAND env var.
  if (NW_HOSTNAMES.has(window.location.hostname)) return 'newwestern';
  if (import.meta.env.VITE_BRAND === 'newwestern') return 'newwestern';
  return 'leftmain';
}
